import { useEffect } from 'react';

const CLEAR_NOTIFICATION_DELAY = 1500;

export const useOverideCssVariableEffect = (variable, value) => {
  useEffect(() => {
    const psuedoRoot = document.querySelector(':root');
    psuedoRoot.style.setProperty(`--llui-${variable}`, value);
    return () => {
      psuedoRoot.style.removeProperty(variable);
    };
  }, [variable, value]);
};

export const useClearNotificationEffect = (
  isNotificationDisplayed,
  notificationName,
  clearSuccessCallback,
) => {
  useEffect(() => {
    if (isNotificationDisplayed) {
      setTimeout(() => {
        clearSuccessCallback(notificationName);
      }, CLEAR_NOTIFICATION_DELAY);
    }
  }, [isNotificationDisplayed, notificationName, clearSuccessCallback]);
};
